import React from 'react';
import Card from './Card';
import ThreeColumn from './ThreeColumn';
import { StaticQuery, graphql } from 'gatsby';


function BlogPreviews() {
  return (
    <StaticQuery
      query={graphql`
              query BlogPreviewsQuery {
                allContentfulBlogPost(
                    sort: {order: DESC, fields: date}
                    limit: 3
                ) {
                  nodes {
                    title
                    slug
                    id
                    excerpt
                    heroImage {
                        fluid {
                            ...GatsbyContentfulFluid_withWebp_noBase64
                        }
                    }
                  }
                }
              }
            `}
      render={data => (
        <ThreeColumn>
          {data.allContentfulBlogPost.nodes.map(node => <Card
            key={node.id}
            image={node.heroImage}
            title={node.title}
            excerpt={node.excerpt}
            to={`/posts/${node.slug}`}/>)}
        </ThreeColumn>
      )}
    />

  )
}

export default BlogPreviews;
